import jApi from './jApi';

export default {
  getSetupFormUi(req) {
    const api = jApi.generateApi();
    return api.get('nocode/studio/form/fetch', { params: req })
      .then(res => res.data);
  },

  getSetupMultiFormUi(req) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/multiple-form-ui/setup/fetch', { params: req })
      .then(res => res.data);
  },

  getRecordData(req) {
    const api = jApi.generateApi();
    return api.get('nocode/studio/record/fetch', { params: req })
      .then(res => res.data);
  },

  getRecordDataV2(req) {
    const api = jApi.generateApi();
    return api.post('nocode/studio/record/fetch-v2', req)
      .then(res => res.data);
  },

  getFunctiondata(req) {
    const api = jApi.generateApi();
    return api.post(`nocode/function?function_name=${req}`, {})
      .then(res => res);
  },

  listFormData(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/record/form', { params })
      .then(res => res.data);
  },

  // FORM UI
  setForm(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/form/set', params)
      .then(res => res.data);
  },

  deleteForm(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/form/delete', { params })
      .then(res => res.data);
  },

  listForm(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/form/fetch', { params })
      .then(res => res);
  },

  // MULTIPLE FORM UI
  setMultiForm(params) {
    const api = jApi.generateApi();
    return api.post('/nocode/multiple-form-ui/setup/set', params)
      .then(res => res.data);
  },

  deleteMultiForm(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/multiple-form-ui/setup/delete', { params })
      .then(res => res.data);
  },

  listMultiForm(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/multiple-form-ui/setup/fetch', { params })
      .then(res => res);
  },

  // FORM DATA
  getListFormData(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/record/form', { params })
      .then(res => res.data);
  },

  // CANVAS
  listCanvas(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/studio/canvas/fetch', { params })
      .then(res => res);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiFormUi.js